export default __webpack_public_path__ + "static/media/stakelogic.57655080.jpg";